import React from "react";
import { motion } from "framer-motion";
import { BookOpen, BellRing, Sparkles } from "lucide-react";

const floatingVariants = {
  animate: {
    y: [0, -12, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut",
    },
  },
};

const textVariants = {
  hidden: { opacity: 0, y: 25 },
  visible: (delay) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay,
      duration: 0.8,
    },
  }),
};

const particles = Array.from({ length: 18 });

const ExamPortalLanding = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top, #fff9ec 0%, #fff5dc 40%, #fdf0c9 100%)",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: "2rem",
        fontFamily: "system-ui",
      }}
    >
      {/* Floating Background Particles */}
      {particles.map((_, i) => (
        <motion.div
          key={i}
          animate={{
            y: [0, -30, 0],
            opacity: [0.2, 0.8, 0.2],
          }}
          transition={{
            duration: 4 + i * 0.4,
            repeat: Infinity,
          }}
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: "rgba(255, 183, 77, 0.4)",
            position: "absolute",
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
          }}
        />
      ))}

      {/* Main Card */}
      <motion.div
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        style={{
          maxWidth: "760px",
          width: "100%",
          background: "rgba(255,255,255,0.85)",
          backdropFilter: "blur(14px)",
          borderRadius: "28px",
          padding: "3rem",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.08)",
          border: "1px solid rgba(255,255,255,0.7)",
        }}
      >
        {/* Logo */}
          <img
            src="https://www.iskconcommunications.org/joomlatools-files/docman-images/iskcon_logo.jpg"
            alt="ISKCON Solapur"
            style={{
              width: "120px",
              height: "120px",
              objectFit: "contain",
              marginBottom: "1.5rem",
            }}
          />

        {/* Heading */}
        <motion.h1
          custom={0.2}
          initial="hidden"
          animate="visible"
          variants={textVariants}
          style={{
            fontSize: "2.8rem",
            fontWeight: "700",
            color: "#7A4E00",
            marginBottom: "1rem",
            fontFamily:'-apple-system'
          }}
        >
          Welcome to Examination Portal, ISKCON Solapur
        </motion.h1>

        {/* Sub heading */}
        <motion.p
          custom={0.4}
          initial="hidden"
          animate="visible"
          variants={textVariants}
          style={{
            fontSize: "1.2rem",
            color: "#6B5A3C",
            lineHeight: "1.9",
            marginBottom: "2rem",
            fontFamily:'monospace'
          }}
        >
          The sacred books are ready. The questions are meditating.
          <br />
          The exam... well... it is still deciding the most auspicious time.
        </motion.p>

        {/* Info Section */}
        <motion.div
          custom={0.6}
          initial="hidden"
          animate="visible"
          variants={textVariants}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.3rem",
            marginTop: "2rem",
            fontFamily: 'cursive'
          }}
        >
          {[
            {
              icon: <BookOpen size={20} />,
              text: "Preparations for the upcoming examination are underway.",
            },
            {
              icon: <BellRing size={20} />,
              text: "The next announcement will arrive before your memory of Chapter 3 fades.",
            },
            {
              icon: <Sparkles size={20} />,
              text: "Until then, continue your study, reflection, and a little revision never hurts.",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.03 }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                padding: "1rem 1.2rem",
                background: "#fffaf0",
                borderRadius: "14px",
                color: "#5D4300",
                border: "1px solid rgba(255,193,7,0.15)",
              }}
            >
              {item.icon}
              <span>{item.text}</span>
            </motion.div>
          ))}
        </motion.div>

        {/* Closing Line */}
        <motion.p
          custom={0.8}
          initial="hidden"
          animate="visible"
          variants={textVariants}
          style={{
            marginTop: "2.5rem",
            fontSize: "1rem",
            color: "#7A6A4A",
            fontFamily:'sans-serif',
            fontStyle: "italic",
          }}
        >
          Stay tuned. The next opportunity to test knowledge and devotion
          shall be announced soon.
        </motion.p>
      </motion.div>

      {/* Bottom Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        style={{
          position: "absolute",
          bottom: "0.2rem",
          fontSize: "0.95rem",
          letterSpacing: "2px",
          color: "#8B6F2D",
          fontWeight: "600",
          textTransform: "uppercase",
        }}
      >
        Jai Prabhupada
      </motion.div>
    </div>
  );
};

export default ExamPortalLanding;